var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { confirmable, createConfirmation } from 'react-confirm';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '../Dialog';
import { Button } from '../Button';
import { ThemeProvider } from '../ThemeProvider';
import theme from '../themes/default.theme';
export var Alert = confirmable(function (_a) {
  var show = _a.show,
      proceed = _a.proceed,
      confirmation = _a.confirmation,
      _a$options = _a.options,
      options = _a$options === void 0 ? {} : _a$options,
      props = __rest(_a, ["show", "proceed", "confirmation", "options"]);

  return React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(Dialog, Object.assign({}, props, {
    opened: show,
    onClose: proceed
  }), React.createElement(DialogTitle, null, options.title), React.createElement(DialogContent, null, confirmation), React.createElement(DialogActions, {
    disableSpacing: true
  }, React.createElement(Button, {
    autoFocus: true,
    onClick: proceed
  }, options.okText))));
});
export var alert = createConfirmation(Alert);